export class Microsoft365UserExclusions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "users",
            "baseName": "users",
            "type": "Array<Microsoft365FilterSelectionRef>",
            "format": ""
        },
        {
            "name": "groups",
            "baseName": "groups",
            "type": "Array<Microsoft365FilterSelectionRef>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365UserExclusions.attributeTypeMap;
    }
    constructor() {
    }
}
